import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import * as commonActions from './../../actions/commonActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as activityActions from './../../actions/activityActions';
import * as dashboardActions from './../../actions/dashboardActions';
import {logout} from './../../redux/modules/auth';
import Modal from 'react-modal';
import styles from './LogoutComponent.less';
import i18next from 'i18next';
import { applyStyle, applyClickActive, applyToHover,setDirection } from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
@connect(
  state => ({
    userDetail: state.auth.userDetail,
    layout: state.dashboardRoot.dashboardReducer.layout,
    tradeBookColumns: state.dashboardRoot.dashboardReducer.tradeBookColumns,
    tempList: state.dashboardRoot.dashboardReducer.tempList,
    deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
    logoutFlag:state.dashboardRoot.dashboardReducer.logoutFlag,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
    language:state.dashboardRoot.commonReducer.language,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    errorLogs:state.dashboardRoot.commonReducer.errorLogs
  }),
    {pushState: push,logout,...commonActions,...instrumentListActions,...tradepanelActions,...activityActions,...dashboardActions})

export default class LogoutComponent extends Component {
  constructor(props){
    super(props);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }
  static propTypes = {
    userDetail: PropTypes.object,
    logout: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    closeSocketData: PropTypes.func.isRequired,
    closeSocketTrade: PropTypes.func.isRequired,
    setLogoutFlag:PropTypes.func,
    logoutFlag:PropTypes.bool,
    layout: PropTypes.array,
    tradeBookColumns:PropTypes.array,
    tempList: PropTypes.array,
    deleteWidgetKey: PropTypes.array,
    checkLockStatus:PropTypes.func,
    addWidgetmodalflag:PropTypes.func,
    setApiFlag:PropTypes.func,
    isAllApiLoaded:PropTypes.func,
    pushState: PropTypes.func,
  }

  showAlertBox = () => {
    try{
      confirmAlert({
        customUI: ({ onClose}) => {
          return (
            <div className='custom-ui'>
              <h1>{i18next.t("exitConfirmationMsg")}</h1>
              <button id="savetmpBtn" onClick={() => {this.savetemplate()
                onClose()}}>{i18next.t("saveExitLayoutMsg")}</button>
              <button id="exitBtn" onClick={() => {this.handleLogout()
                onClose() }}>{i18next.t("exit")}</button>
              <button id="cancelBtn" onClick={() => {this.props.setLogoutFlag(false)
                onClose()}}>{i18next.t("cancel")}</button>
            </div>
          )
        }
      })
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'showAlertBox', component:"LogoutComponent"});
    }
  }

  handleLogout = () => {
    try{
      if(this.props.errorLogs.length !==0){
        this.props.sendErrorLogs(this.props.errorLogs)
      }
      this.props.closeforcedModal();
      this.props.saveSuccess;
      this.props.closeSocketData();
      this.props.closeSocketTrade();
      this.props.resetState();
      this.props.loadTemplateFlag(false);
      localStorage.setItem('logoutClose',true);
      this.props.clearHeartRateInterval();
      this.props.clearHeartOrdInterval();
      // this.props.resetStateSocket();
      this.props.setLogoutFlag(false);
      this.props.logout(this.props.userDetail);
      this.props.checkLockStatus(false);
      this.props.addWidgetmodalflag(true);
      this.props.setApiFlag(false);



      // this.props.closeforcedModal();
      // this.props.saveSuccess;
      // this.props.closeSocketData();
      // this.props.closeSocketTrade();
      // this.props.resetState();
      // this.props.loadTemplateFlag(false);
      // this.props.loadTemplateFlag(false);
      // localStorage.setItem('logoutClose',true);
      // this.props.clearHeartRateInterval();
      // this.props.clearHeartOrdInterval();
      // this.props.checkLockStatus(false);
      // this.props.addWidgetmodalflag(true);
      // this.props.setApiFlag(false);
      // this.props.pushState('/login');
      // if(localStorage.getItem('user')!==null || localStorage.getItem('user') !== 'null'){
      //   this.props.logout(this.props.userDetail);
      // }

      /*localStorage.setItem('DCO','');
      localStorage.setItem('DFA','');
      localStorage.setItem('EURUSD','');
      localStorage.setItem('XAGUSD','');
      localStorage.setItem('XAUEUR','');
      localStorage.setItem('XAUUSD','');
      localStorage.setItem('XPDUSD','');
      localStorage.setItem('XPTUSD','');*/
      localStorage.removeItem('DCO');
      localStorage.removeItem('DFA');
      localStorage.removeItem('EURUSD');
      localStorage.removeItem('XAGUSD');
      localStorage.removeItem('XAUEUR');
      localStorage.removeItem('XAUUSD');
      localStorage.removeItem('XPDUSD');
      localStorage.removeItem('XPTUSD');
      this.props.isAllApiLoaded(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleLogout', component:"LogoutComponent"});
    }
  }

  savetemplate=()=>{
    try{
      const {deleteWidgetKey, layout} = this.props;
      if (deleteWidgetKey) {
        deleteWidgetKey.forEach((item) => {
          layout.forEach((element, index) => {
            if (item === element.i) {
              layout.splice(index, 1);
            }
          });
        });
      }
      let isCmdtySelected = true;
      let array = layout;
      array = array.filter(item => {
        return item.name === 'Trade';
      });
      const tradeWithoutCmdty = [];
      array.map((item) => {
        if (!('cmdtyPair' in item)) {
          isCmdtySelected = false;
          tradeWithoutCmdty.push(item.i);
        }
      });
        // to remove trade panel without commodity pair
        if (tradeWithoutCmdty) {
          tradeWithoutCmdty.forEach((item) => {
            layout.forEach((element, index) => {
              if (item === element.i) {
                layout.splice(index, 1);
              }
            });
          });
        }
        let tempName='';
        let tempCode='';
        let mode='';
        if(this.props.tempList.length<1){
          tempName="default";
          tempCode="0";
          mode='A';
        }else {
          tempName=this.props.tempList[0].N;
          tempCode=this.props.tempList[0].C;
          mode='E';
        }
        let isDefault=1;
        this.props.saveTemplate(layout,this.props.tradeBookColumns, tempName,tempCode, isDefault,mode).then(
          response => {
            this.handleLogout();
          }
        );
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'savetemplate', component:"LogoutComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.logoutbox;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"savetmpBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"exitBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"cancelBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"msg","elementType":"normal", "applyTo":"all", "tagNames":"p"}
      // ];
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"btnWrapDiv", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"logoutConfmMsg","elementType":"normal", "applyTo":"single", "tagNames":"div"}
      ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName(styles.savetmpBtn)[0], "classNames":"savetmpBtn"},
          {"elmToHover":thisComponent.getElementsByClassName(styles.exitBtn)[0], "classNames":"exitBtn"},
          {"elmToHover":thisComponent.getElementsByClassName(styles.cancelBtn)[0], "classNames":"cancelBtn"}
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"LogoutComponent"});
    }
  }

  render() {
    return (
      <Modal isOpen={this.props.logoutFlag}  id="logoutModal" className={`${styles.logOutModal} ${this.props.language} logoutbox`} onAfterOpen={this.afterOpenModal}>
        <div ref="logoutbox" className="mdlWrap" >
          <div className={`${styles.header} header`}>
            <span className={styles.msgTitle}>{i18next.t("logout")}</span>
            <span className={`${styles.closeImg} closeIcon commonCloseIcon`} onClick={() => {this.props.setLogoutFlag(false)}}><MUIIconWithTooltip icon={'Close'} className="dp48 closeBtn" title={i18next.t("close")}/></span>
          </div>
          <p className="msg logoutConfmMsg">{i18next.t("exitConfirmationMsg")}</p>
          <div className={`${styles.btnWrap} col-md-12 btnWrapDiv`}>
            <button id="savetmpBtn" className={`${styles.savetmpBtn} savetmpBtn`} onClick={this.savetemplate}>{i18next.t("saveExitLayoutMsg")}</button>
            <button id="exitBtn" className={`${styles.exitBtn} exitBtn`} onClick={this.handleLogout}>{i18next.t("exit")}</button>
            <button id="cancelBtn" className={`${styles.cancelBtn} cancelBtn`} onClick={() => {this.props.setLogoutFlag(false)}}>{i18next.t("cancel")}</button>
          </div>
        </div>
      </Modal>
    );
  }
}
